"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSettings = exports.scheduleSurvey = exports.getUserIfModified = exports.getUser = void 0;
function getUser(client) {
    return client.post('get_user', {});
}
exports.getUser = getUser;
function getUserIfModified(client, opts) {
    return client.post('get_user_if_modified', {
        last_modified_timestamp: opts.lastModifiedTimestamp
    });
}
exports.getUserIfModified = getUserIfModified;
function scheduleSurvey(client, opts) {
    return client.post('schedule_survey', { type: opts.type });
}
exports.scheduleSurvey = scheduleSurvey;
function setSettings(client, opts) {
    return client.post('set_settings', {
        settings: opts.settings
    });
}
exports.setSettings = setSettings;
